import styles from '@/legacy/components/input/Input.module.scss';
import veriStyles from '@/legacy/components/input/verifyStyles.module.scss';

export const errorStyle = (message: string | undefined) => {
	if (message) return `${styles.input} ${styles.inputError}`;
	return `${styles.input}`;
};

export const disableInputStyle = (message: string | undefined) => {
	if (message) return `${styles.input} ${styles.inputError}`;
	return `${styles.input}`;
};

/**
 * 버튼 스타일
 * @param text
 * @param before
 * @param message
 * @returns
 */
export const veriStyle = (text: string, before: string, message: string | undefined, isVerification: boolean) => {
	console.log(!text, text === '', before !== '', !message);
	console.log('veriStyl', message);
	if (text && !message && isVerification) return `${veriStyles.verify} ${veriStyles.verified}`;
	// 입력된 텍스트가 있고 에러 메세지가 없을 때
	if (text && !message) return `${veriStyles.verify} ${veriStyles.verifying}`;
	// 그냥 before가 있으면
	if (before !== '') return `${veriStyles.verify} ${veriStyles.verified}`;
	// 텍스트가 없거나 , 에러메세지가 없으면
	return `${veriStyles.verify} `;
};

/**
 * 메세지 있고 검증 다 되있으면 체크 박스 버튼 활성화
 * @param message
 * @param isVerification
 * @returns
 */
export const verifyCheckBoxStyle = (message: string, isVerification: boolean) => {
	if (message !== '' && isVerification) return `${veriStyles.verifyIcon}`;
	return `${veriStyles.verifyIcon} ${veriStyles.disable}`;
};

/**
 *  verify input 비활성화 조건
 * @returns
 */
export const isVaildInput = () => {
	return false;
};

/**
 *  verify input style
 * @param text
 * @param before
 * @param message
 * @returns
 */
export const VaildInputStyle = (bool: boolean) => {
	// 입력된 텍스트가 있고 에러 메세지가 없을 때
	if (bool) return `${veriStyles.verify} `;
	return `${veriStyles.verify} `;
};

// errorStyle(errors.username?.message)
// isVaildInput VaildInputStyle
